
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  projectListItemEdit: {
    id: "ProjectListItemEdit.edit",
    defaultMessage: "Edit",
  }, 
  projectListItemDelete: {
    id: "ProjectListItemDelete.delete",
    defaultMessage: "Delete",
  }, 
  projectListItemLinkTitle: {
    id: "ProjectListItemLinkTitle.title",
    defaultMessage: "Settings",
  }, 
});

export default MESSAGES;